module.exports = __webpack_public_path__ + "static/media/1417950333.a1bf6861.ttf";